import { render, staticRenderFns } from "./WTable.vue?vue&type=template&id=0b457c6e&"
import script from "./WTable.vue?vue&type=script&lang=js&"
export * from "./WTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports